import React, { useEffect } from 'react';
import { getCurrentUserInfo } from '@services/Cookies';
import { useGetAccessibleDatabasePacksList } from '@hooks/useBackendApi';

// ログイン直後（クッキーによる自動ログイン含む）に
// 利用可能なデータベースパック一覧をプリフェッチして
// フロント側キャッシュを温める
const PrefetchBootstrap: React.FC = () => {
  const { getAccessibleDatabasePacksList } = useGetAccessibleDatabasePacksList();

  useEffect(() => {
    const current = getCurrentUserInfo();
    if (current?.id) {
      // 既にキャッシュがあればフック側で即返却される
      getAccessibleDatabasePacksList(current.id).catch(() => {
        /* プリフェッチ失敗はUIに影響させない */
      });
    }
  }, []);

  return null;
};

export default PrefetchBootstrap;

